"use client";

import { Collapsible as CollapsiblePrimitive } from "radix-ui";

export type CollapsibleProps = React.ComponentProps<typeof CollapsiblePrimitive.Root>;
export type CollapsibleTriggerProps = React.ComponentProps<
  typeof CollapsiblePrimitive.CollapsibleTrigger
>;
export type CollapsibleContentProps = React.ComponentProps<
  typeof CollapsiblePrimitive.CollapsibleContent
>;

/** React 18-compatible scoped wrapper for the upstream collapsible primitive. */
export const Collapsible = (props: CollapsibleProps) => (
  <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
);
/** Trigger for {@link Collapsible}. */
export const CollapsibleTrigger = (props: CollapsibleTriggerProps) => (
  <CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />
);
/** Content region for {@link Collapsible}. */
export const CollapsibleContent = (props: CollapsibleContentProps) => (
  <CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />
);
